<template>
    <el-dialog title="定位"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
            custom-class="map-dialog-custom"
            @close="closeDialog"
            width="600px">
        <div class="dialog-map-layout">
            <div v-show="type === 'yxdt'" class="map-ctrl" @click="showDzdt">电子地图</div>
            <div v-show="type === 'dzdt'" class="map-ctrl" @click="showYxdt">影像地图</div>
            <j-grid-ctrl ref="gridCtrlDom" :rule="[9,12,14]" :rangeCode="$store.state.user.areaCode" class="grid-select" type="select" placeholder="所属区域" v-model="code" @change="getXYByGridCode" />
            <jsx-gis-map ref="map" :env="gis" @load="mapLoadEvent" @click="mapClickEvent" />
        </div>
        <div v-if="!readOnly" slot="footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="saveEvent" :loading="submitLoad">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import Vue from 'vue'
    import { gis } from "../../../../config";
    import JsxGisMap from "../jsx/JsxGisMap";
    import JGridCtrl from "../../JGridCtrl/JGridCtrl";
    import queryMixins from "../mixins/queryMixins";
    import layerMixins from "../mixins/layerMixins";
    export default {
        name: 'GisDialog',
        components: {
            JsxGisMap: Vue.component('JsxGisMap', { mixins: [JsxGisMap, queryMixins, layerMixins] }),
            JGridCtrl
        },
        props: {
          readOnly: {
              type: Boolean,
              default: false
          },
          point: Object,
          latitude: [String, Number],
          longitude: [String, Number],
          gridCode: [String, Number],
          address: String
        },
        data () {
            return {
                type: 'dzdt',
                gis,
                dialogVisible: true,
                submitLoad: false,
                selectPoint: {},
                code: ''
            }
        },
        created () {
          if (this.latitude && this.longitude) {
              return this.pointHandle({
                  x: this.longitude,
                  y: this.latitude,
                  latitude: this.latitude,
                  longitude: this.longitude,
                  gridCode: this.gridCode,
                  address: this.address
              })
          }
          if (this.point) this.pointHandle(this.point)
        },
        methods: {
            async getXYByGridCode (point) {
                const areaCode = point.code
                const { data } = await this.$http.get(`/api/grids/center`, {
                    params: { areaCode }
                })
                this.pointHandle({
                    gridCode: areaCode,
                    latitude: data.data.centerY,
                    longitude: data.data.centerX,
                    x: data.data.centerX,
                    y: data.data.centerY,
                    address: (point.pathArr && point.pathArr.join('')) + data.data.name
                })
                this.$refs.map.GisMapClearPoint()
                this.$refs.map.GisMapDrawPoint(this.selectPoint, true)
            },
            showDzdt () {
                this.type = 'dzdt'
                this.$refs.map.GisMapShowElectronMap()
            },
            showYxdt () {
                this.type = 'yxdt'
                this.$refs.map.GisMapShowSimulationMap()
            },
            pointHandle (point) {
                this.code = point.gridCode || point.areaCode || ''
                this.selectPoint = {
                    areaCode: this.code,
                    gridCode: this.code,
                    latitude: point.y,
                    longitude: point.x,
                    x: point.x,
                    y: point.y,
                    address: point.address
                }
            },
            mapLoadEvent () {
                if (this.selectPoint.latitude && this.selectPoint.longitude) return this.$refs.map.GisMapDrawPoint(this.selectPoint, true)
                // 未选点情况下接口获取所属区域的中心点
                this.getXYByGridCode({ code: this.$store.state.user.areaCode })
            },
            mapClickEvent (event) {
                this.selectPoint = {
                    latitude: event.mapPoint.latitude,
                    longitude: event.mapPoint.longitude,
                    x: event.mapPoint.x,
                    y: event.mapPoint.y
                }
                this.$refs.map.GisMapClearPoint()
                this.$refs.map
                    .GisMapQueryTask(this.selectPoint, ['BM', 'NAME', 'SSXZQH', 'SSJB', 'SSSQ'])
                    .then((arr) => {
                        if (arr.length > 0) {
                            const res = arr[0].attributes
                            if (!res.BM.includes(this.$store.state.user.areaCode)) {
                                this.$message.warning('当前区域非您的所属区域，无法选择')
                                this.code = ''
                                this.selectPoint = {}
                                return
                            }
                            this.$refs.map.GisMapDrawPoint(this.selectPoint)
                            this.code = res.BM
                            this.selectPoint = {
                                ...this.selectPoint,
                                name: res.NAME,
                                gridCode: res.BM,
                                address: `${res.SSXZQH}${res.SSJB}${res.SSSQ}${res.NAME}`
                            }
                        } else {
                            this.$message.warning('当前区域无网格信息')
                            this.code = ''
                            this.selectPoint = {}
                        }
                    })
            },
            closeDialog () {
                this.$emit('update:close', false)
            },
            updateData () {
                this.$emit(`update:latitude`, this.selectPoint.latitude || '')
                this.$emit(`update:longitude`, this.selectPoint.longitude || '')
                this.$emit(`update:gridCode`, this.selectPoint.gridCode || '')
                this.$emit(`update:address`, this.selectPoint.address || '')
            },
            saveEvent () {
                this.$emit('select', this.selectPoint)
                this.updateData()
                this.closeDialog()
            }
        }
    }
</script>

<style lang="scss">
    .dialog-map-layout {
        position: relative;
        height: 400px;
        .grid-select {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 200px!important;
            z-index: 2;
            background-color: rgba(37,51,77, .9);
            border-radius: 5px;
        }
        .map-ctrl {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 10px;
            left: 10px;
            width: 96px!important;
            height: 32px;
            z-index: 2;
            background-color: rgba(46,128,252,.8);
            color: #fff;
            border-radius: 4px;
            font-size: 14px;
            cursor: pointer;
        }
    }
</style>
